import { IScenarioDataModel } from '../../../../data-models/scenario.data-model';
import { PermissionKey } from '../../../../services/PermissionAndRolesKeys';
import { PermissionService } from '../../../../services/PermissionService';
import { useCurrentUser } from '../../../../services/hooks/useCurrentUser';

export function useCanEditScenario(scenario: Partial<IScenarioDataModel> | null) {
  const currentUser = useCurrentUser();

  if (!scenario) {
    return false;
  }

  return (
    PermissionService.get().hasPermission(PermissionKey.canEditScenarios) &&
    (!scenario.createdBy || scenario.createdBy === currentUser?.email)
  );
}
